import React, { FC } from 'react';

import Input from '../../components/Input/Input';
import { InputFields, RawField } from '../../forms';

import Logo from '../Logo';

const RequestReset: FC = () => {
  const FormFields = {
    email: { ...InputFields.email, required: true },
  } as const satisfies Record<string, RawField>;

  return (
    <form className='auth-form' method='post'>
      <Logo />
      <h3>パスワード初期化 URL送信</h3>
      <p>ユーザー登録時のEmailアドレスを入力してください</p>
      <Input
        label={FormFields.email.label}
        inputProps={{
          tabIndex: FormFields.email.tabIndex,
          required: FormFields.email.required,
          maxLength: FormFields.email.maxLength,
          pattern: FormFields.email.pattern,
        }}
        type={FormFields.email.type}
        name={FormFields.email.name}
        size='small'
        fullWidth
        sx={{ width: '300px' }}
      />

      <button className='btn btn--main btn--fix' type='submit'>
        送信
      </button>
    </form>
  );
};

export default RequestReset;
